import React from 'react'
import { Link } from 'gatsby'
import { Layout, Showcase, SectionTitle, Header } from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        title={data.title}
        site={data.site}
        state="develop"
        slug={data.slug + '/develop/'}
      />
      <Layout
        title={data.title}
        description={data.description}
        state="develop"
        site={data.site}
        slug={data.slug + '/develop/'}
      >
        <SectionTitle>Usage</SectionTitle>
        <Showcase
          site={data.site}
          title="Select"
          text={
            <p>
              In the active state, a dropdown presents input options with their
              own hover states. Once the user selects an option, the dropdown
              disappears, and the selected state appears. The error state takes
              the form of an{' '}
              <Link
                to={'/' + data.site + '/components/inline-error/develop/'}
                className="link"
              >
                input error
              </Link>{' '}
              component.
            </p>
          }
          code={code.checkbox}
        >
          <select class="c-select" id="select-1">
            <option value="">Month</option>
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
        </Showcase>
        <hr />
        <SectionTitle>States</SectionTitle>
        <p>
          In addition to the default state, each select component also has a
          predetermined active state, focus state and a selected state. Use the{' '}
          <span className="inline__code">c-select--error</span> class to apply
          the error state to the select container.
        </p>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>

        <Showcase
          site={data.site}
          title="Select Box Error"
          text={
            <p>
              A select box in the error state must be used with an{' '}
              <Link
                to={'/' + data.site + '/components/inline-error/design/'}
                className="link"
              >
                input error
              </Link>{' '}
              component to guide the user in correcting the error.
            </p>
          }
        >
          <select class="c-select c-select--error" id="select-1">
            <option value="">Select your pet</option>
            <option value="1">Princess</option>
            <option value="2">Moose</option>
            <option value="3">Oscar</option>
          </select>
          <span class="c-inline-error">
            <i class="icon icon--error c-inline-error__icon"></i>
            <span class="c-inline-error__content">
              Make a selection before moving on.
            </span>
          </span>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  checkbox: `<select class="c-select"">
    <option value="">Select</option>
    <option value="1">One</option>
    <option value="2">Two</option>
    <option value="3">Three</option>
</select>
`,
}
